import DUpload from './src';

DUpload.install = Vue => {
  Vue.component('DUpload', DUpload);
};

export default DUpload;
